// extracted by mini-css-extract-plugin
export default {"wrapper":"adminPanel_wrapper__CCCf6","buttons":"adminPanel_buttons__CCXhS"};